import { ref, watch, onMounted } from 'vue'

export const useCookie = () => {
  const set = (key, value, options = {}) => {
    const cookieKeyValueString = `${key}=${encodeURIComponent(value)}; `
    const cookieOptionsString = Object.entries(options).map(option => `${option[0]}=${option[1]}; `).join('');
    
    document.cookie = `${cookieKeyValueString}${cookieOptionsString}`
  }

  const get = (key) => {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${key}=`))
      ?.split('=')[1];
  }

  return { get, set };
}

